import GREENTILL_STORE_THEME_DEFAULTS from "util/storeThemeDefaults";
import Button from "components/button/Button";
import React, { useState } from "react";
import { useEffect } from "react";
import { Input } from "reactstrap";
import { compose } from "redux";
import enhancer from "./validator";

const StoreForm = props => {
  const {
    handleChange,
    handleBlur,
    errors,
    loading,
    touched,
    submitCount,
    onSubmit,
    values,
    action,
    setFieldTouched,
    setFieldValue,
    editedData
  } = props;
  const [uploadImage, setUploadImage] = useState(null);

  useEffect(() => {
    if (editedData) {
      setFieldValue("images", null);
    }
  }, [editedData]);

  const Error = props => {
    const field1 = props.field;
    if (
      ((errors[field1] && touched[field1]) || submitCount > 0) &&
      !Array.isArray(errors[field1])
    ) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span></span>;
    }
  };

  const handleImage = (e, setValue) => {
    if (e.target.files[0]) {
      let fileObj = e.target.files[0];
      // setImageObj(fileObj);
      if (fileObj) {
        const img = new Image();

        img.src = window.URL.createObjectURL(fileObj);

        img.onload = function() {
          const width = img.naturalWidth,
            height = img.naturalHeight;

          window.URL.revokeObjectURL(img.src);
          setValue("width", width);
          setValue("height", height);
          setFieldTouched("image", true, true);

          setValue("image", URL.createObjectURL(fileObj));
          setValue("images", fileObj);
          setUploadImage(URL.createObjectURL(fileObj));
        };
      } else {
        //No file was input or browser doesn't support client side reading
        // form.submit();
      }
    } else {
      setUploadImage(null);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    let { values, isValid, handleSubmit } = props;
    if (isValid) {
      onSubmit(values, action);
    }
    handleSubmit();
  };

  const handleResetThemeDefaults = () => {
    Object.entries(GREENTILL_STORE_THEME_DEFAULTS).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
  };

  return (
    <div>
      <form
        onSubmit={e => {
          handleSubmit(e);
        }}
      >
        <div className="form-group">
          <label className="fs-16 medium-text">
            Store Logo <span className="asterisk">*</span>
          </label>
          <div className="file-upload">
            <label className="c-btn c-secondary  form-button fs-16 demi-bold-text mt-15">
              Upload logo
              <input
                id="image"
                className="file-upload__input"
                name="file-upload"
                type="file"
                style={{ display: "none" }}
                accept="image/jpg,image/png,image/jpeg"
                onChange={e => handleImage(e, setFieldValue)}
                onBlur={handleBlur}
              />
            </label>
          </div>
          {(uploadImage || values.image) && (
            <img
              src={uploadImage ? uploadImage : values.image}
              alt=""
              className="mtb-15"
              style={{
                width: "200px",
                borderRadius: "4%",
                height: "150px",
                background: "#404040"
              }}
            />
          )}
          <Error field="image" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Store Name <span className="asterisk">*</span>
          </label>
          <input
            type="text"
            className="form-control react-form-input"
            id="name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
            placeholder="Store Name"
          />
          <Error field="name" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Store Description</label>
          <textarea
            className="form-control react-form-input"
            id="storeDescription"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.storeDescription}
            placeholder="Store Description"
          />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Is Active</label>
          <Input
            type="select"
            id="isActive"
            className="form-control react-form-input"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.isActive}
          >
            <option value={false}>False</option>
            <option value={true}>True</option>
          </Input>
          <Error field="isActive" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Is Loyalty Partner</label>
          <Input
            type="select"
            id="storeLoyaltyPartner"
            className="form-control react-form-input"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.storeLoyaltyPartner}
          >
            <option value={false}>False</option>
            <option value={true}>True</option>
          </Input>
          <Error field="storeLoyaltyPartner" />
        </div>
        <div
          className="form-group"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "12px"
          }}
        >
          <div>
            <label className="fs-16 medium-text" style={{ fontWeight: 600 }}>
              White-label Theme Colors
            </label>
            <p className="text-muted fs-13 mb-0">
              Customize this store&apos;s CMS appearance and receipt page
              branding. Social and app store links are configured under Receipt
              Page settings.
            </p>
          </div>
          <button
            type="button"
            className="c-btn c-outline-secondary"
            onClick={handleResetThemeDefaults}
            style={{ whiteSpace: "nowrap" }}
          >
            Reset to GreenTill defaults
          </button>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">Primary Color</label>
            <p className="text-muted fs-12 mb-2">
              Receipt page header and buttons
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="primaryColor"
                value={values.primaryColor || "#1F3B6F"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.primaryColor}
                onChange={e => setFieldValue("primaryColor", e.target.value)}
                placeholder="#1F3B6F"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">Secondary Color</label>
            <p className="text-muted fs-12 mb-2">Receipt page accents</p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="secondaryColor"
                value={values.secondaryColor || "#4CAF50"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.secondaryColor}
                onChange={e => setFieldValue("secondaryColor", e.target.value)}
                placeholder="#4CAF50"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">Sidebar Color</label>
            <p className="text-muted fs-12 mb-2">Left navigation background</p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="sidebarColor"
                value={values.sidebarColor || "#222437"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.sidebarColor}
                onChange={e => setFieldValue("sidebarColor", e.target.value)}
                placeholder="#222437"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">Menu Highlight Color</label>
            <p className="text-muted fs-12 mb-2">Active and hover menu items</p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="menuHighlightColor"
                value={values.menuHighlightColor || "#10b981"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.menuHighlightColor}
                onChange={e =>
                  setFieldValue("menuHighlightColor", e.target.value)
                }
                placeholder="#10b981"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">Topbar Color</label>
            <p className="text-muted fs-12 mb-2">Header bar background</p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="topbarColor"
                value={values.topbarColor || "#ffffff"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.topbarColor}
                onChange={e => setFieldValue("topbarColor", e.target.value)}
                placeholder="#ffffff"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">Menu Text Color</label>
            <p className="text-muted fs-12 mb-2">
              Inactive sidebar menu labels
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="menuTextColor"
                value={values.menuTextColor || "#cbd5e1"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.menuTextColor}
                onChange={e => setFieldValue("menuTextColor", e.target.value)}
                placeholder="#cbd5e1"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
          <div className="form-group" style={{ flex: "1 1 220px" }}>
            <label className="fs-14 medium-text">
              CMS Accent / Button Color
            </label>
            <p className="text-muted fs-12 mb-2">Primary admin panel buttons</p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="color"
                id="accentColor"
                value={values.accentColor || "#10b981"}
                onChange={handleChange}
                style={{
                  width: "50px",
                  height: "36px",
                  border: "none",
                  cursor: "pointer"
                }}
              />
              <input
                type="text"
                className="form-control react-form-input"
                value={values.accentColor}
                onChange={e => setFieldValue("accentColor", e.target.value)}
                placeholder="#10b981"
                style={{ maxWidth: "140px" }}
              />
            </div>
          </div>
        </div>

        <div
          className="form-group"
          style={{
            marginTop: "8px",
            padding: "16px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            background: "#f8fafc",
            maxWidth: "320px"
          }}
        >
          <label className="fs-14 medium-text" style={{ fontWeight: 600 }}>
            CMS Theme Preview
          </label>
          <div
            style={{
              marginTop: "12px",
              borderRadius: "10px",
              overflow: "hidden",
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
            }}
          >
            <div
              style={{
                background: values.topbarColor || "#ffffff",
                padding: "10px 12px",
                fontSize: "12px",
                fontWeight: 600,
                color: "#334155",
                borderBottom: "1px solid #e2e8f0"
              }}
            >
              Header
            </div>
            <div
              style={{
                display: "flex",
                minHeight: "140px"
              }}
            >
              <div
                style={{
                  width: "42%",
                  background: values.sidebarColor || "#222437",
                  padding: "10px 8px"
                }}
              >
                <div
                  style={{
                    background: values.menuHighlightColor || "#10b981",
                    color: "#ffffff",
                    borderRadius: "8px",
                    padding: "8px 10px",
                    fontSize: "12px",
                    fontWeight: 600,
                    marginBottom: "6px"
                  }}
                >
                  Dashboard
                </div>
                <div
                  style={{
                    color: values.menuTextColor || "#cbd5e1",
                    padding: "8px 10px",
                    fontSize: "12px"
                  }}
                >
                  Users
                </div>
                <div
                  style={{
                    color: values.menuTextColor || "#cbd5e1",
                    padding: "8px 10px",
                    fontSize: "12px"
                  }}
                >
                  Receipts
                </div>
              </div>
              <div
                style={{
                  flex: 1,
                  background: "#f5f7fb",
                  padding: "12px"
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    background: values.accentColor || "#10b981",
                    color: "#fff",
                    fontSize: "11px",
                    fontWeight: 600,
                    marginBottom: "10px"
                  }}
                >
                  Save
                </div>
                <div
                  style={{
                    height: "28px",
                    borderRadius: "6px",
                    background: values.primaryColor || "#1F3B6F",
                    marginBottom: "8px",
                    opacity: 0.9
                  }}
                />
                <div
                  style={{
                    height: "10px",
                    width: "70%",
                    borderRadius: "4px",
                    background: values.secondaryColor || "#4CAF50",
                    opacity: 0.85
                  }}
                />
                <p
                  className="text-muted fs-11 mt-2 mb-0"
                  style={{ fontSize: "11px" }}
                >
                  Receipt branding preview
                </p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Button
            type="submit"
            loading={loading}
            disabled={loading}
            className="c-btn c-info form-button fs-16 demi-bold-text mr-15"
            style={{ maxWidth: "125px" }}
            dataStyle="expand-right"
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default compose(enhancer)(StoreForm);
